import { useState } from 'react';

const useFacebook = () => {
  const [settings, setSettings] = useState();
  const [user, setUser] = useState();

  return {
    user,
    setUser,
    settings,
    setSettings
  };
};

export default useFacebook;
